export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z\"/>"
};